<template>
  <div class="quotationWarehouse">
    <van-form label-width="120px" :show-error="false" @submit="onSubmit">
      <div class="title" v-if="WMId">{{ $t.onlineOrder.editTitle2 }}</div>
      <div class="title" v-else>{{ $t.onlineOrder.addTitle2 }}</div>

      <van-field
        v-model="form.WarehouseCode"
        :label="$t.onlineOrder.warehouseCode"
        label-class="number-label"
        readonly
        v-if="WMId"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(form.WarehouseCode)"
            native-type="button"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>

      <van-field
        v-model="form.WarehouseNameSn"
        :label="$t.onlineOrder.warehouseName"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.WarehouseAddress"
        :label="$t.onlineOrder.warehouseAddress"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="3"
      />

      <van-field
        v-model="form.WarehouseContact1"
        :label="$t.onlineOrder.warehouseContact1"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.WarehouseContact2"
        :label="$t.onlineOrder.warehouseContact2"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.WarehouseContactPhone"
        :label="$t.onlineOrder.warehousePhone"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.WarehouseContactEmail"
        :label="$t.onlineOrder.warehouseEmail"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.WarehouseOperationTime"
        :label="$t.onlineOrder.warehouseTime"
        :placeholder="$t.meta.input"
      />

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "quotationWarehouse",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      WMId: "",
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
    };
  },
  created() {
    const { WMId } = this.$route.query;
    if (WMId) {
      this.WMId = WMId;
      this.loadWarehouseInfo();
    }
  },
  methods: {
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    initData() {
      this.form = {
        WarehouseNameSn: "",
        WarehouseAddress: "",
        WarehouseContact1: "",
        WarehouseContact2: "",
        WarehouseContactPhone: "",
        WarehouseContactEmail: "",
        WarehouseOperationTime: "",
      };
    },
    loadWarehouseInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          WMId: this.WMId,
        };
        this.$api.onlineOrderManagement
          .loadWarehouseInfo(param)
          .then((res) => {
            this.form = res.data;
            this.$commonMethod.fieldRefresh(".quotationWarehouse");
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CompanyId = this.CompanyId;
      var request = null;
      if (this.WMId) {
        request = this.$api.onlineOrderManagement.editWarehouseInfo(param);
      } else {
        request = this.$api.onlineOrderManagement.addWarehouseInfo(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.quotationWarehouse {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .avatarImg {
    width: 50px;
    height: 50px;
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 100%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
}
</style>
